<template>
  <transition name="login-fade">
    <div v-show="$store.state.showLogin" class="login-dialog-container">
      <div v-show="$store.state.showLogin" class="mask"></div>
      <div class="login-dialog">
        <div class="btn-close" @click="showLogin"></div>
        <!-- 登录注册 -->
        <div v-if="loginStatus === 'SignIn' || loginStatus === 'SignUp'">
          <div class="title-wrap">
            <div
              @click="handleSwitch('SignIn')"
              :class="{ 'title-current': loginStatus === 'SignIn' }"
              class="title"
            >
              {{ $t("loginTitle") }}
            </div>
            <div
              v-if="getDomainFn"
              @click="handleSwitch('SignUp')"
              class="title"
              :class="{ 'title-current': loginStatus === 'SignUp' }"
            >
              {{ $t("signUp") }}
            </div>
          </div>
          <!-- 登录内容 -->
          <div v-if="loginStatus === 'SignIn'">
            <SignIn :isAgree="isChecked" />
          </div>
          <!-- 注册内容 -->
          <div v-if="loginStatus === 'SignUp'">
            <SignUp :isAgree="isChecked" />
          </div>
          <p class="tips" v-if="isCN">
            <CustomCheckbox v-model="isChecked">
              {{ $t("loginTips0") }}
              <a :href="termsUrl">{{ $t("loginTips2") }}</a>
              {{ $t("loginTips3") }}
              <a :href="protocolUrl">{{ $t("loginTips4") }}</a>
            </CustomCheckbox>
          </p>
          <p class="tips" v-else>
            {{ $t("loginTips1") }}
            <a :href="termsUrl">{{ $t("loginTips2") }}</a>
            {{ $t("loginTips3") }}
            <a :href="protocolUrl">{{ $t("loginTips4") }}</a>
          </p>

          <p class="phone-tips" v-if="!getDomainFn">
            <span @click="handleSwitch('PhoneSignIn')">
              {{ $t("phoneLogin") }}</span
            >
          </p>
        </div>
        <div v-if="loginStatus === 'ChangePassword'">
          <div class="title-wrap">
            <div class="title-modla">
              {{ $t("changeTitle") }}
            </div>
          </div>
          <ChangePassword />
        </div>
        <div v-if="loginStatus === 'ResetPassword'">
          <div class="title-wrap">
            <div class="title-modla">
              {{ $t("resetTitle") }}
            </div>
          </div>
          <ResetPassword />
        </div>
        <div v-if="loginStatus === 'Invited'">
          <div class="title-wrap">
            <div class="title-modla">
              {{ $t("invitationCode") }}
            </div>
          </div>
          <InvitationCode />
        </div>
        <div v-if="loginStatus === 'PhoneSignIn'">
          <div class="title-wrap">
            <div class="title" style="cursor: default">
              {{ $t("phoneLogin") }}
            </div>
          </div>
          <!-- 登录内容 -->
          <PhoneSignIn :isAgree="isChecked" />
          <p class="tips" v-if="isCN">
            <CustomCheckbox v-model="isChecked">
              {{ $t("loginTips0") }}
              <a :href="termsUrl">{{ $t("loginTips2") }}</a>
              {{ $t("loginTips3") }}
              <a :href="protocolUrl">{{ $t("loginTips4") }}</a>
            </CustomCheckbox>
          </p>
          <p class="tips" v-else>
            {{ $t("loginTips1") }}
            <a :href="termsUrl">{{ $t("loginTips2") }}</a>
            {{ $t("loginTips3") }}
            <a :href="protocolUrl">{{ $t("loginTips4") }}</a>
          </p>

          <p class="phone-tips">
            <span @click="handleSwitch('SignIn')">{{ $t("emailLogin") }}</span>
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { getDomainFn } from "@/utils/env";
import SignIn from "@/components/Home/LoginComponents/SignIn.vue";
import SignUp from "@/components/Home/LoginComponents/SignUp.vue";
import ChangePassword from "@/components/Home/LoginComponents/ChangePassword.vue";
import ResetPassword from "@/components/Home/LoginComponents/ResetPassword.vue";
import InvitationCode from "@/components/Home/LoginComponents/InvitationCode.vue";
import PhoneSignIn from "@/components/Home/LoginComponents/PhoneSignIn.vue";
import CustomCheckbox from "@/components/Input/CustomCheckbox.vue";

export default {
  name: "LoginDialog",
  components: {
    SignIn,
    SignUp,
    ChangePassword,
    ResetPassword,
    InvitationCode,
    PhoneSignIn,
    CustomCheckbox,
  },
  data() {
    const browserLocale = navigator.language || navigator.userLanguage;
    const isCN = browserLocale.indexOf("zh") > -1;
    return {
      isCN: isCN,
      isChecked: !isCN,
    };
  },
  computed: {
    getDomainFn() {
      return getDomainFn();
    },
    termsUrl() {
      return getDomainFn() ? `/protocol/terms.html` : `/protocol/terms_zh.html`;
    },
    protocolUrl() {
      return getDomainFn()
        ? `/protocol/privacy.html`
        : `/protocol/privacy_zh.html`;
    },
    loginStatus: {
      get() {
        return this.$store.state.loginStatus;
      },
      set(value) {
        this.$store.commit("setLoginStatus", value);
      },
    },
  },
  methods: {
    handleSwitch(status) {
      this.loginStatus = status;
    },
    showLogin() {
      // if (this.loginStatus === "Invited") return;
      this.$store.commit("setShowLogin", false);
      let that = this;
      if (this.loginStatus !== "Invited") {
        var timerId = setTimeout(function () {
          if (!that.getDomainFn) {
            that.loginStatus = "PhoneSignIn";
          } else {
            that.loginStatus = "SignIn";
          }
          clearTimeout(timerId);
        }, 300);
      }
      // this.$router.replace("/");
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.login-dialog {
  width: 357px;
  min-height: 270px;
  background: #ffffff;
  border-radius: 9px;
  position: absolute;
  padding: 30px 42px;
  color: #000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .title-wrap {
    display: flex;

    .title {
      cursor: pointer;
      font-size: 20px;
      margin-bottom: 23px;
      margin-right: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #060808;
    }

    .title-modla {
      font-size: 20px;
      font-size: 18px;
      font-weight: 400;
      color: #060808;
      margin-bottom: 13px;
      font-weight: 600;
    }

    .title-current {
      font-weight: 600;
    }
  }

  .btn-close {
    height: 48px;
    width: 48px;
    position: absolute;
    right: 0;
    top: 0;
    background: url(../../assets/images/iconsV2/icon_modal_close.png) no-repeat
      center transparent;
    background-size: 12px;
    cursor: pointer;
  }

  .input-title {
    height: 15px;
    font-size: 11px;
    font-weight: 400;
    color: #060808;
    line-height: 15px;
  }

  .tips {
    font-size: 12px;
    opacity: 0.6;
    text-align: center;
    padding: 18px 20px 0 16px;

    a {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}

.mask,
.login-dialog-container {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(16px);
}

.login-dialog-container {
  z-index: 999;
}

.login-fade-enter-active,
.login-fade-leave-active {
  transition: all 0.5s ease;
  transform: translateY(0);
}

.login-fade-enter,
.login-fade-leave-active {
  opacity: 0;
  transform: translateY(-50%);
}

.phone-tips {
  font-size: 12px;
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: #000000;
  text-decoration: underline;
  text-align: center;
  margin-top: 15px;
  span {
    cursor: pointer;
  }
}
</style>
